import { render } from "./NcrmEmailMarketingWorkspace.vue?vue&type=template&id=5480995c&scoped=true"
import script from "./NcrmEmailMarketingWorkspace.vue?vue&type=script&lang=js"
export * from "./NcrmEmailMarketingWorkspace.vue?vue&type=script&lang=js"

import "./NcrmEmailMarketingWorkspace.vue?vue&type=style&index=0&id=5480995c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5480995c"]])

export default __exports__